import React, { useEffect, useRef, useState } from 'react'
import { FiSearch } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

function Search({showSearchbar,hideSearchBar}) {
  const inputRef = useRef(null);

    const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      navigateToProductPage();
    }
  };

  const filterProductList = () => {
    navigateToProductPage();
  };

  const navigateToProductPage = () => {
    hideSearchBar(false)
    navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
  };
  
  useEffect(() => {
        
    const handleResize = () => {
      if (window.innerWidth >= 768) {
      }
    };
    // Initial call to set the layout based on the initial window width
    handleResize();
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  useEffect(() => {
    if (showSearchbar) {
      inputRef.current.focus();
    }
  }, [showSearchbar]);

  return (
    <div className="z-50 fixed bg-white shadow-md py-2 w-full search-container">
      
      <div className="flex justify-between item-center p-4 search-box container">
        <input
          ref={inputRef}
          className="shadow-none m-0 p-0 border-none w-[80%] outline-none"
          type="text"
          placeholder="Search for products in this collection"
          value={searchQuery}
          onChange={handleSearchInputChange}
          onKeyDown={handleKeyPress}
        />
        <FiSearch
          className="text-primary text-xl hover:text-black cursor-pointer"
          onClick={filterProductList}
        />
      </div>
    </div>
  )
}

export default Search